const features = [
  {
    icon: 'ri-database-2-line',
    title: 'Tysiące Produktów',
    desc: 'Nasz Kakobuy Spreadsheet zawiera starannie wyselekcjonowaną kolekcję produktów z kategorii shoes, clothing, accessories i wiele więcej – wszystko w jednym miejscu.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Codzienne Aktualizacje',
    desc: 'Arkusz jest codziennie odświeżany – dodajemy nowe linki i usuwamy nieaktualne, dzięki czemu zawsze masz dostęp do świeżych ofert.',
  },
  {
    icon: 'ri-global-line',
    title: 'Dla Polski i Europy',
    desc: 'Kakobuy Spreadsheet został zoptymalizowany specjalnie dla użytkowników z Polski – wszystkie produkty można zamówić z dostawą do Polski.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Sprawdzone Linki',
    desc: 'Każdy link w arkuszu jest weryfikowany – znajdziesz tylko aktywne oferty od sprawdzonych sprzedawców z dobrymi opiniami.',
  },
];

const WhySection = () => {
  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <p className="text-primary-500 text-sm tracking-widest uppercase mb-3 font-medium">
            Dlaczego warto
          </p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Dlaczego <span className="text-primary-500">Kakobuy Spreadsheet</span>?
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            Nasz arkusz to nie tylko lista linków – to kompletne narzędzie zakupowe, które oszczędza Twój czas i pomaga znaleźć najlepsze okazje.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200 rounded-xl p-6 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4">
                <i className={`${f.icon} text-lg`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;